export enum BookmarkType {
    AUTOMATIC,
    MANUAL
}

export default class Bookmark {
    publicationId!: string;
    page!: number;
    type!: BookmarkType;
    date!: Date;

    constructor(data: Partial<Bookmark>) {
        Object.assign(this, data);
    }

}
